// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';
export var PlayFilled = createSvgIcon({ LeftToRight: React.createElement(React.Fragment, null,
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { fill: "currentColor", stroke: "transparent", fillRule: "evenodd", d: "M2.5382.113a1 1 0 011.0353.0678l10 7a1 1 0 010 1.6384l-10 7A.9998.9998 0 012 15V1a1 1 0 01.5382-.887z", clipRule: "evenodd" }))),
        React.createElement("defs", null)), }, 'small');
//# sourceMappingURL=PlayFilled.js.map